<script lang="ts">
    import { round } from "@/Util/utils";
    import type {RaceAchievability} from "../../modules/ProgramAchievability"
    type $$Props = RaceAchievability["carb_rate"] & {
        carb_rate_target: number,
        ignore_carb_rate: boolean
    }
    export let status: $$Props["status"]
    export let carb_rate_achievable: $$Props["carb_rate_achievable"]
    export let carb_rate_target: $$Props["carb_rate_target"]
    export let ignore_carb_rate: $$Props["ignore_carb_rate"]
</script>
<div>
    <div class="text-sm text-slate-500">
        {#if ignore_carb_rate}
        Carb Rate is unrestricted and is not factored into estimates.
        {:else if status === "fine"}
        The estimated carb rate for this race is <span class="font-medium">{round(carb_rate_achievable)}.</span>
        {:else}
        The estimated carb rate for this race is <span class="font-medium">{round(carb_rate_achievable)}</span> and is above your target <span class="font-medium">{round(carb_rate_target)}</span>. Your fuelling may be compromised.
        {/if}
    </div>
</div>